import * as A from 'constants/actions'

export const didStartPrePaymentSurvey = () => ({
  type: A.DID_START_PRE_PAYMENT_SURVEY,
})
export const didTrackIdentify = () => ({
  type: A.DID_TRACK_IDENTIFY,
})
